import React from 'react';

import { RegionHeaderItem } from './RegionHeaderItem';
import { REGION_ORDER } from '../../constants/regions';
import type { SequenceData } from '../../types';
import { getSequenceRegions } from '../../utilities/sequenceHelpers';

/**
 * RegionHeader Component
 *
 * Renders the header row showing region labels (FWR1, CDR1, FWR2, etc.)
 * for the sequence alignment view
 */

interface RegionHeaderProps {
  sampleSequence: SequenceData | undefined;
  showFWR: boolean;
  highlightedRegion: string | null;
  onRegionClick?: (region: string | null) => void;
}

export const RegionHeader = React.memo<RegionHeaderProps>(({ sampleSequence, showFWR, highlightedRegion, onRegionClick }) => {
  const regions = getSequenceRegions(sampleSequence);
  if (!regions) {
    return null;
  }

  return (
    <div className="flex text-[10px] font-medium mb-1">
      {REGION_ORDER.map(({ key, label, isCDR }) => {
        const regionSeq = regions[key as keyof typeof regions];
        if ((!showFWR && !isCDR) || !regionSeq) {
          return null;
        }
        const isHighlighted = highlightedRegion === key;

        return (
          <RegionHeaderItem
            key={key}
            regionKey={key}
            label={label}
            isCDR={isCDR}
            regionSeq={regionSeq}
            isHighlighted={isHighlighted}
            onRegionClick={onRegionClick}
          />
        );
      })}
    </div>
  );
});

RegionHeader.displayName = 'RegionHeader';
